var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColoredAppleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8917 20.659C13.7484 21.7674 12.5 21.5924 11.2984 21.0674C10.0267 20.5307 8.86003 20.5074 7.51836 21.0674C5.83836 21.7907 4.9517 21.5807 3.94836 20.659C-1.74497 14.7907 -0.904971 5.85402 5.55836 5.52736C7.13336 5.60902 8.23003 6.39069 9.1517 6.46069C10.5284 6.18069 11.8467 5.37569 13.3167 5.48069C15.0784 5.62069 16.4084 6.32069 17.2834 7.58069C13.6434 9.76236 14.5067 14.5574 17.8434 15.899C17.1784 17.649 16.315 19.3874 14.88 20.6707L14.8917 20.659ZM9.03503 5.45736C8.86003 2.85569 10.9717 0.709023 13.3984 0.499023C13.7367 3.50902 10.6684 5.74902 9.03503 5.45736Z",
    fill: "#00C13A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredAppleIcon);
export default __webpack_public_path__ + "static/media/colored_apple_icon.d441b5fd5cf2bd5d5877f1ab286eaa90.svg";
export { ForwardRef as ReactComponent };